 <!-- DELETE-MODAL -->
 <div class="master-modal delete-modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title">Cancel order item </h4>
        <div class="modal_close_btn">
          <span (click)="dialogClose('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <!-- Modal-Body -->
      <!-- Modal content-->
      <perfect-scrollbar class="modal-body-scrollbar">
        <div mat-dialog-content>
          <div class="modal-body">
            <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
              fxLayoutAlign="start stretch" fxLayoutGap="8px">
              <div fxLayout="column" fxFlex="100" fxFlexFill>
                <div class="notification-delete">
                  <p>Do you really want to cancel this order item?</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </perfect-scrollbar>
      <!-- Modal-Footer -->
    <div class="modal-footer">
      <div mat-dialog-actions class="modal_footer">
        <button mat-button (click)="dialogClose('no')" class="modal-cancel-btn modal-footer-btn">
          <span>No</span>
        </button>
        <button mat-button class="modal-save-btn global-btn modal-footer-btn"  (click)="updateStatus()">
          <span>Yes</span>
        </button>
      </div>
    </div>

    </div>
  </div>
</div>
